import React, { useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import logo from '../../assets/images/artwer/logo-dark-text.png';

// ART-WER contact section — no form, no action buttons (per request).
// Heading + lead sit together with the company data below the map.
const WHATSAPP_NUMBER = '31616136942'; // +31 6 16 13 69 42

const ContactMain = () => {
  const mapRef = useRef(null);

  // Service-area map: whole NL in view, main working region highlighted around
  // Biddinghuizen. Leaflet + OpenStreetMap (loaded from CDN, no API key).
  useEffect(() => {
    const el = mapRef.current;
    if (!el || el._leaflet_id) return;
    const bidd = [52.4536, 5.6939];
    const map = L.map(el, { scrollWheelZoom: false, attributionControl: true }).setView([52.12, 5.3], 7);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 18, attribution: '&copy; OpenStreetMap',
    }).addTo(map);
    L.circle(bidd, { radius: 78000, color: '#E63A27', weight: 2, opacity: 0.85, fillColor: '#E63A27', fillOpacity: 0.10 }).addTo(map);
    L.circleMarker(bidd, { radius: 7, color: '#fff', weight: 2, fillColor: '#E63A27', fillOpacity: 1 })
      .addTo(map)
      .bindTooltip('ART-WER · Biddinghuizen', { direction: 'top' });
    return () => { map.remove(); };
  }, []);

  return (
    <>
      {/* Service-area map — regio Biddinghuizen binnen NL */}
      <section className="google-map-one" id="contact">
        <div
          ref={mapRef}
          className="google-map__one artwer-servicemap"
          role="img"
          aria-label="Kaart van het werkgebied: regio Biddinghuizen, Flevoland en Midden-Nederland"
        />
      </section>

      <section className="contact-page">
        <div className="container">
          <div className="contact-page__inner">
            <img src={logo} className="artwer-contact-logo" alt="ART-WER Aannemingsbedrijf" />
            <p className="contact-page__sub-title">Contact</p>
            <h3 className="contact-page__title">Eén telefoontje. Eén opname. Eén partner.</h3>
            <p className="artwer-contact-lead">
              Bel of mail vandaag nog voor een vrijblijvende opname op locatie. U spreekt direct de
              vakman — geen wachtlijst, geen tussenpersoon.
            </p>
          </div>
        </div>

        <div className="container">
          <div className="contact-page__contact-list">
            <div className="row">
              <div className="col-xl-4 col-lg-4">
                <div className="contact-page__contact-list-single">
                  <div className="contact-page__contact-list-icon">
                    <span className="icon-call" />
                  </div>
                  <div className="contact-page__contact-list-content">
                    <h3>Telefoon &amp; WhatsApp</h3>
                    <p><a href="tel:+31616136942">+31 6 16 13 69 42</a></p>
                    <p><a href={`https://wa.me/${WHATSAPP_NUMBER}`} target="_blank" rel="noreferrer">WhatsApp ons</a></p>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-lg-4">
                <div className="contact-page__contact-list-single">
                  <div className="contact-page__contact-list-icon">
                    <span className="icon-envelope" />
                  </div>
                  <div className="contact-page__contact-list-content">
                    <h3>E-mail</h3>
                    <p><a href="mailto:info@art-wer.nl">info@art-wer.nl</a></p>
                    <p>Werkgebied: Flevoland &amp; Midden-Nederland</p>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-lg-4">
                <div className="contact-page__contact-list-single">
                  <div className="contact-page__contact-list-icon">
                    <span className="icon-location" />
                  </div>
                  <div className="contact-page__contact-list-content">
                    <h3>Adres</h3>
                    <p>Lucernehof 15<br />8256 CH Biddinghuizen</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactMain;
